import React from "react"
import { RiDoubleQuotesL } from "react-icons/ri"
import "./style.scss"

const QuotesTab = ({ quotes = [] }) => {
  return (
    <div className="shared-insights-quotes-tab">
      {quotes.map((quote, idx) => (
        <div className="shared-insights-quote-container" key={idx}>
          <div>
            <RiDoubleQuotesL fontSize={35} color="#325f7d" />
          </div>
          <p>{quote}</p>
        </div>
      ))}
    </div>
  )
}

export default QuotesTab
